import { InitOptions } from "i18next";
export const fallbackLng = "en";
export const defaultNS = [
  "common",
  "end_of_shift",
  "invoice_arrival",
  "navigation",
  "pos",
  "product",
  "sales",
  "settings",
  "stockorder",
  "stock_counts",
  "quote",
  "customer",
  "gift_card",
  "gift_voucher",
  "api_key_vault",
  "onboarding",
];

export const cookieName = "i18next";
export const languages = [fallbackLng, "en-GB"] as const;

export const getOptions = (
  lng = fallbackLng,
  ns: InitOptions["ns"] = defaultNS
): InitOptions => ({
  debug: true,
  lng,
  fallbackLng,
  supportedLngs: languages,
  ns,
  fallbackNS: defaultNS,
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
  keySeparator: ".",
  react: {
    useSuspense: false,
  },
});

interface LanguageDetails {
  /** Name of the language in it's own language */
  name: string;
  /** 0: Sunday, 1: Monday */
  weekStart: 0 | 1;
  timeFormat: "12h" | "24h";
}

export const languageDetails: Record<
  (typeof languages)[number],
  LanguageDetails
> = {
  en: {
    // English (US)
    name: "English (US)",
    weekStart: 0,
    timeFormat: "12h",
  },
  "en-GB": {
    // English (UK)
    name: "English (UK)",
    weekStart: 1,
    timeFormat: "12h",
  },
};
